import React, { useState } from "react";
import ViewButton from "./Buttons/ViewButton";
import ReviewButton from "./Buttons/ReviewButton";
import CheckWithDate from "./CheckWithDate";
import { format } from "date-fns";
import { Box, Modal } from "@mui/material";
import ViewReleaseOfInformation from "./forms/ViewReleaseOfInformation";
import ViewRevoke from "./forms/ViewRevoke";
import CheckWithDateRevoked from "./CheckWithDateRevoked";
import StandardDrawer from "./forms/StandardDrawer";
import "./forms/AdmissionDocumentRedesign.css";

function FormLineRoi(props) {
  const styleModal2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: "auto",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const [showViewModal, setShowViewModal] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const openRevokeModal = () => {
    setShowRevokeModal(true);
  };

  const closeRevokeModal = () => {
    setShowRevokeModal(false);
  };

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy");
  }

  function formatDate2(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMM yyyy");
  }

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMedium2 form-line-roi-row light-grey-form"
          : "formLineMedium2 form-line-roi-row grey-form"
      }
    >
      <StandardDrawer
        open={showViewModal}
        onClose={closeViewModal}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewReleaseOfInformation
          {...props}
          firstName={props.firstName}
          closemodal={closeViewModal}
        />
      </StandardDrawer>

      <Modal
        open={showRevokeModal}
        onClose={closeRevokeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal2}>
          <ViewRevoke
            documentId={props.documentId}
            subcollectionDocumentId={props.subcollectionDocumentId}
            {...props}
            firstName={props.firstName}
            closemodal={closeRevokeModal}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <div className="formLineRoiBlock1">{props.title}</div>

      <div className="formLineRoiBlock2">{props.relationship}</div>

      <div className="formLineRoiBlock2bis">
        <CheckWithDate checked={true} content={formatDate(props.signedOn)} />
      </div>

      <div className="formLineRoiBlock2tris">
        <CheckWithDateRevoked
          title={props.revokedBy}
          checked={props.revoked}
          content={props.revoked ? formatDate2(props.dateRevoked) : ""}
        />
      </div>

      <div className="formLineRoiBlock3">
        <ViewButton handleOpen={openViewModal} />
        {props.revoked ? "" : <ReviewButton handleOpen={openRevokeModal} />}
      </div>
    </div>
  );
}

export default FormLineRoi;
